import { EpimsBaseEntityDto } from './epim-base.dto';
export class CleanUpStatusDto extends EpimsBaseEntityDto {

  id: string;
  CleanUpStatusName: string;
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;

}